import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.selectors.requestActivitySelectors.QBooks', {
    postApprovalChangeDetected: 'Changes have been made in QuickBooks Online after approval.',
    rejectedExternally: 'Request has been rejected by QuickBooks Online.',
    emailToVendorSent: '{templateName} has been sent to the Vendor.',
    emailToCustomerSent: '{templateName} has been sent to the Customer.',
    statusRejected: 'The status has been rejected by QuickBooks Online.',
});
